import { render, staticRenderFns } from "./UserP2PReviews.vue?vue&type=template&id=10bb12c7&scoped=true&"
import script from "./UserP2PReviews.vue?vue&type=script&lang=js&"
export * from "./UserP2PReviews.vue?vue&type=script&lang=js&"
import style0 from "./UserP2PReviews.vue?vue&type=style&index=0&id=10bb12c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb12c7",
  null
  
)

export default component.exports